import { useState } from "react";
import styles from "../HealthChat.module.css";

const PCOSLogo = () => (
  <svg width="32" height="32" viewBox="0 0 24 24">
    <circle cx="12" cy="12" r="10" fill="#FFE4EC" />
    <circle cx="12" cy="10" r="3" fill="var(--ava-bg-secondary)" />
  </svg>
);
const FertilityLogo = () => (
  <svg width="32" height="32" viewBox="0 0 24 24">
    <circle cx="12" cy="12" r="10" fill="#E6F7F1" />
    <path d="M12 8v8M8 12h8" stroke="#00A676" strokeWidth="2" />
  </svg>
);
const PregnancyLogo = () => (
  <svg width="32" height="32" viewBox="0 0 24 24">
    <circle cx="12" cy="12" r="10" fill="#F3EFFF" />
    <path
      d="M12 7a5 5 0 0 1 5 5c0 3-5 7-5 7s-5-4-5-7a5 5 0 0 1 5-5z"
      fill="#673AB7"
    />
  </svg>
);

const PROGRAMS_DATA = [
  {
    id: "pcos",
    label: "PCOS Care Program",
    desc: "Manage PCOS symptoms and improve your quality of life.",
    meta: "8 weeks • 24 sessions",
    tag: "Popular",
    tagType: "orange",
    Icon: PCOSLogo,
  },
  {
    id: "fertility",
    label: "Fertility Boost Program",
    desc: "Holistic program to improve fertility.",
    meta: "12 weeks • 36 sessions",
    tag: "New",
    tagType: "green",
    Icon: FertilityLogo,
  },
  {
    id: "pregnancy",
    label: "Healthy Pregnancy Program",
    desc: "Guidance for a healthy you and baby.",
    meta: "40 weeks • Ongoing",
    tag: "Popular",
    tagType: "orange",
    Icon: PregnancyLogo,
  },
];
const STEP_CONFIG = {
  title: "Health Programs",
  subtitle: "Explore our programs designed for your wellbeing",
};
export default function HealthProgramsScreen({ onBack, onContinue }) {
  const [selectedId, setSelectedId] = useState(null);

  return (
    <div className={styles.programsScreen}>
      <button className={styles.selectDoctorBack} onClick={onBack}>
        ← Back
      </button>
      {/* <div className={styles.headerArea}>
        <h2 className={styles.programsTitle}>Health Programs</h2>
        <p className={styles.programsSub}>
          Explore our programs designed for your wellbeing
        </p>
      </div> */}
   <div className={styles.symptomPickerBotRow}>
        <img src="/images/chatbotFemCare.svg" alt="bot" width={48} height={48} className={styles.symptomPickerBotImg} />
        <div className={`${styles.symptomPickerBotBubble} ${styles.CBbodyText}`}>
          <strong>{STEP_CONFIG.title}</strong>
          <p style={{ fontSize: "0.85rem", margin: 0, opacity: 0.9 }}>
            {STEP_CONFIG.subtitle}
          </p>
        </div>
        </div>
      <div className={styles.container}>
        {PROGRAMS_DATA.map((prog) => (
          <div
            key={prog.id}
            className={`${styles.card} ${selectedId === prog.id ? styles.selectedCard : ""}`}
            onClick={() => setSelectedId(prog.id)}
          >
            {prog.tag && (
              <span className={`${styles.badge} ${styles[prog.tagType]}`}>
                {prog.tag}
              </span>
            )}

            <div className={styles.cardMain}>
              <div className={styles.iconContainer}>
                <prog.Icon />
              </div>
              <div className={styles.content}>
                <div className={styles.title}>{prog.label}</div>
                <div className={styles.desc}>{prog.desc}</div>
                <div className={styles.meta}>{prog.meta}</div>
              </div>
              <div className={styles.selectionCircle}>
                {selectedId === prog.id && (
                  <div className={styles.radioInner} />
                )}
              </div>
            </div>
          </div>
        ))}
      </div>

      {selectedId && (
        <div className={styles.stickyFooter}>
          <button
            className={styles.visitModelContinueBtn}
            onClick={() => onContinue(selectedId)}
          >
            Continue
          </button>
        </div>
      )}
    </div>
  );
}
